module.exports = __webpack_public_path__ + "media/images/icon__profile-57889ca0c0dbd3fa1c03a4d84f3d6394.png";